"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    I18nProvider: ()=>I18nProvider,
    useI18n: ()=>useI18n,
    defaultLang: ()=>defaultLang
});
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _merge = /*#__PURE__*/ _interopRequireDefault(require("lodash/merge"));
const _helpers = require("./helpers");
const _defaults = /*#__PURE__*/ _interopRequireDefault(require("./defaults"));
const _defaultsEs = /*#__PURE__*/ _interopRequireDefault(require("./defaults_es"));
const _defaultsFr = /*#__PURE__*/ _interopRequireDefault(require("./defaults_fr"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const I18nContext = /*#__PURE__*/ _react.default.createContext({
    language: _defaults.default,
    setLanguage: ()=>{},
    text: ()=>'',
    t: ()=>'',
    isLoading: false,
    languageLabel: '',
    setLanguageLabel: ()=>{}
});
const I18nProvider = ({ children , language: _language = _defaults.default , languagesEdit =[]  })=>{
    // merge language with default
    const mergeLanguage = (lang, label)=>{
        let selectedLanguage = (0, _merge.default)({}, _defaults.default, languagesEdit);
        switch(label){
            case 'English (US)':
                break;
            case 'French (FR)':
                selectedLanguage = (0, _merge.default)({}, selectedLanguage, _defaultsFr.default);
                break;
            case 'Spanish (ES)':
                selectedLanguage = (0, _merge.default)({}, selectedLanguage, _defaultsEs.default, languagesEdit);
                break;
        }
        return (0, _merge.default)({}, selectedLanguage, lang);
    };
    const [language, setLanguageInternal] = (0, _react.useState)(_defaults.default);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [languageLabel, setLanguageLabel] = (0, _react.useState)('');
    (0, _react.useEffect)(()=>{
        const mergedLanguage = (0, _merge.default)({}, _defaults.default, _language);
        mergedLanguage && setLanguageInternal(mergedLanguage);
    }, [
        _language
    ]);
    const setLanguage = (label, lang)=>{
        setIsLoading(true);
        const _lang = languagesEdit.length > 0 && languagesEdit.find((l)=>l.label === label);
        if (_lang && _lang.i18n && Object.keys(_lang.i18n).length > 0) {
            const editL = (0, _merge.default)({}, lang, _lang.i18n);
            setLanguageInternal(mergeLanguage(editL, label));
        } else {
            setLanguageInternal(mergeLanguage(lang, label));
        }
        setLanguageLabel(label);
        setTimeout(()=>{
            setIsLoading(false);
        }, 1000);
    };
    const text = (0, _react.useCallback)((reach, values)=>{
        return (0, _helpers.getMessage)(language, reach, values);
    }, [
        language
    ]);
    return /*#__PURE__*/ _react.default.createElement(I18nContext.Provider, {
        value: {
            language,
            setLanguage,
            text,
            t: text,
            isLoading,
            languageLabel,
            setLanguageLabel
        }
    }, children);
};
const useI18n = ()=>_react.default.useContext(I18nContext);
const defaultLang = _defaults.default;
